import React, { Component } from 'react'
import CollapsibleSection from '../../../../controls/CollapsibleSection'
import DeductibleItem from '../commonDetails/DeductibleItem'

class DeductibleItems extends Component {
  constructor (props) {
    super(props)
    this.loadCharts = this.loadCharts.bind(this)
    this.unloadCharts = this.unloadCharts.bind(this)
    this.deductibleItem = React.createRef()
    this.itemId = `deductibleItem${props.key}`
    this.state = { expandedKey: false }
  }

  loadCharts () {
    this.deductibleItem.current.chartDeductibleFamily.loadChart()
    this.deductibleItem.current.chartDeductibleIndividual.loadChart()
  }

  unloadCharts () {
    this.deductibleItem.current.chartDeductibleFamily.unloadChart()
    this.deductibleItem.current.chartDeductibleIndividual.unloadChart()
  }

  handlePanelExpandedChanged = panelKey => (event, expanded) => {
    this.setState({ expandedKey: expanded ? panelKey : false })
    if (expanded) {
      this.loadCharts()
    } else {
      this.unloadCharts()
    }
  }

  render () {
    const props = this.props
    const data = props.data
    return (
      <div className='deductibleItems'>
        <CollapsibleSection
          id={this.itemId}
          showMuiBorder={false}
          heading={data.description}
          expanded={this.state.expandedKey === this.itemId}
          onExpanded={this.handlePanelExpandedChanged(this.itemId)}>
          <DeductibleItem content={data}
            ref={this.deductibleItem}
            deductibleIndex={props.index}
          />
        </CollapsibleSection>
      </div>
    )
  }
}

export default DeductibleItems



// WEBPACK FOOTER //
// ./src/widgets/Member/benefitsWidgets/commonDetails/DeductibleItems.js